function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Share"
}, /*#__PURE__*/React.createElement("path", {
  d: "M255.1 283.5H28.3l.1-198.6h63.7v28.3H56.7v141.9h170.1V113.2h-35.5V84.9h63.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.2 52.1L141.8 0 89.2 52.3l20 20.1 18.4-18.3v94.8h28.3V54l18.3 18.2z"
}))));